import { Injectable } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';

@Injectable({
    providedIn: 'root'
})
export class FormsService
{
    public markControlsDirty (group: UntypedFormGroup | UntypedFormArray): void
    {
        for (const ctrlKey in group.controls)
        {
            const abstractControl = group.controls[ctrlKey];

            if (abstractControl instanceof UntypedFormGroup || abstractControl instanceof UntypedFormArray)
            {
                this.markControlsDirty(abstractControl);
            }
            else
            {
                abstractControl.markAsDirty();
            }
        }
    }
}
